function doExlcudeProductPrice(totalPrice, cartItems) {
  const excludeProducts = JSON.parse(document.querySelector('#exclude-products').innerHTML)

  let totalExcludePrice = 0

  cartItems.items.forEach(item => {
    if (excludeProducts.find(subItem => subItem.id === item.product_id)) {
      totalExcludePrice += item.final_line_price
    }
  })

  return totalPrice - totalExcludePrice
}

document.addEventListener('DOMContentLoaded', () => {
  let loading = false
  let flkty

  if (!customElements.get('free-gift-progress')) {
    customElements.define('free-gift-progress', class FreeGiftProgress extends HTMLElement {
      constructor() {
        super()
        this.progressSettings = JSON.parse(this.querySelector('#free-gift-tier-amount').innerHTML)
        const rate = Number(window.Shopify.currency.rate)
        if (this.progressSettings.tierOneAmountLocal) {
          this.progressSettings.tierOneAmount = this.progressSettings.tierOneAmountLocal / rate;
        }
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.cartTotalPrice = this.progressSettings.cartTotalPrice + this.progressSettings.thresholdAmount

        this.cartTotalShippingPrice = this.cartTotalPrice
        this.cartTotalPrice = doExlcudeProductPrice(this.cartTotalPrice, this.cartItems)

        if (this.querySelector('#free-gift-multiple-bar')) {
          this.onUpdateMultipleBar()
        } else {
          this.onUpdateOneBar()
        }
      }

      progressSettings = {}
      cartItems = {}
      cartTotalPrice = 0
      cartTotalShippingPrice = 0

      onUpdateMultipleBar() {
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency

        let oneText = ''
        let oneWidth = ''
        if (this.cartTotalShippingPrice < this.progressSettings.tierOneAmount * rate) {
          const oneAmount = this.progressSettings.tierOneAmount * rate

          if (this.querySelector('[for="tier-one-currency"]'))
            this.querySelector('[for="tier-one-currency"]').innerHTML = currency + (oneAmount / 100).toFixed(2)

          oneText = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          oneWidth = this.cartTotalShippingPrice / (this.progressSettings.tierOneAmount * rate) * 100
        } else {
          oneText = this.progressSettings.tierOneFullfilText
          oneWidth = 100
        }
        if (this.querySelector('#tier-one-bar'))
          this.querySelector('#tier-one-bar').style.width = `${oneWidth}%`

        if (this.querySelector('#tier-one-fullfil-text') && oneWidth === 100) {
          this.querySelector('#tier-one-fullfil-text').innerHTML = oneText
        } else if (this.querySelector('#tier-one-text')) {
          this.querySelector('#tier-one-text').innerHTML = oneText
        }

        let twoText = ''
        let twoWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          const twoAmount = this.progressSettings.tierTwoAmount * rate

          if (this.querySelector('[for="tier-two-currency"]'))
            this.querySelector('[for="tier-two-currency"]').innerHTML = currency + (twoAmount / 100).toFixed(2)

          twoText = this.progressSettings.tierTwoText.replace('$money', currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2))
          twoWidth = this.cartTotalPrice / (this.progressSettings.tierTwoAmount * rate) * 100
        } else {
          twoText = this.progressSettings.tierTwoFullfilText
          twoWidth = 100
        }

        if (this.querySelector('#tier-two-bar'))
          this.querySelector('#tier-two-bar').style.width = `${twoWidth}%`

        if (this.querySelector('#tier-two-fullfil-text') && twoWidth === 100) {
          this.querySelector('#tier-two-fullfil-text').innerHTML = twoText
        } else if (this.querySelector('#tier-two-text')) {
          this.querySelector('#tier-two-text').innerHTML = twoText
        }

        let threeText = ''
        let threeWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          const threeAmount = this.progressSettings.tierThreeAmount * rate

          if (this.querySelector('[for="tier-three-currency"]'))
            this.querySelector('[for="tier-three-currency"]').innerHTML = currency + (threeAmount / 100).toFixed(2)

          threeText = this.progressSettings.tierThreeText.replace('$money', currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2))
          threeWidth = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        } else {
          threeText = this.progressSettings.tierThreeFullfilText
          threeWidth = 100
        }
        if (this.querySelector('#tier-three-bar'))
          this.querySelector('#tier-three-bar').style.width = `${threeWidth}%`

        if (this.querySelector('#tier-three-fullfil-text') && threeWidth === 100) {
          this.querySelector('#tier-three-fullfil-text').innerHTML = threeText
        } else if (this.querySelector('#tier-three-text')) {
          this.querySelector('#tier-three-text').innerHTML = threeText
        }
      }

      isFirstInCart() {
        if (this.progressSettings.autoRemoveFirst) {
          return true
        }

        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (firstProduct) {
          let freeProductData = JSON.parse(firstProduct.querySelector('#free-product-variants').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                return true
              }
            }
          }
        }

        return false
      }

      onUpdateOneBar() {
        let text = ''
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency
        let width = this.progressSettings.showTierFour ?
          this.cartTotalPrice / (this.progressSettings.tierFourAmount * rate) * 100
          : this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        if ( this.cartTotalShippingPrice < this.progressSettings.tierOneAmount * rate ) {
          width = this.progressSettings.showTierFour ?
          this.cartTotalShippingPrice / (this.progressSettings.tierFourAmount * rate) * 100
          : this.cartTotalShippingPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        }

        const oneLeft = (this.progressSettings.tierOneAmount / this.progressSettings.tierFourAmount) * 100
        const twoLeft = (this.progressSettings.tierTwoAmount / this.progressSettings.tierFourAmount) * 100
        const threeLeft = (this.progressSettings.tierThreeAmount / this.progressSettings.tierFourAmount) * 100

        if (this.querySelector('#one-bar-tier-one-title .money'))
          this.querySelector('#one-bar-tier-one-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierOneAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-two-title .money'))
          this.querySelector('#one-bar-tier-two-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierTwoAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-three-title .money'))
          this.querySelector('#one-bar-tier-three-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierThreeAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-four-title .money'))
          this.querySelector('#one-bar-tier-four-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierFourAmount * rate / 100).toFixed(2)}`

        if (this.querySelector('[data-tier="one"]'))
          this.querySelector('[data-tier="one"]').style.left = `${oneLeft}%`
        if (this.querySelector('#one-bar-tier-one-title')) {
          this.querySelector('#one-bar-tier-one-title').style.left = `${0}%`
          this.querySelector('#one-bar-tier-one-title').style.transform = `none`
        }

        if (this.progressSettings.showTierFour) {
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.left = `${twoLeft}%`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title').style.left = `${50}%`
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.left = `${threeLeft}%`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title').style.left = `${50}%`

          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.right = `0`
          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.transform = `translateX(0)`
        } else {
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.display = 'none'
          if (this.querySelector('#one-bar-tier-three-title')) {
            this.querySelector('#one-bar-tier-three-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-three-title').style.transform = `translateX(0)`
          }
        }
        if (this.progressSettings.tierOneAmount != 0 && this.cartTotalShippingPrice < this.progressSettings.tierOneAmount * rate ) {
          if(document.querySelector('.subtotal.free-shipping-note')) document.querySelector('.subtotal.free-shipping-note').style.display === 'none';
        } else {
          if(document.querySelector('.subtotal.free-shipping-note')) document.querySelector('.subtotal.free-shipping-note').style.display === 'block';
        }
        if (this.progressSettings.tierOneAmount != 0 && this.cartTotalShippingPrice < this.progressSettings.tierOneAmount * rate ) {
          text = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate || !this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')

          // 不显示第二个free gift
          if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
            text = this.progressSettings.tierThreeText.replace('$money', currency + ((this.progressSettings.tierThreeAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          } else {
            text = this.progressSettings.tierThreeFullfilText.replace(this.isFirstInCart() ? 'Add to bag below.' : '', '')
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
        } else if (this.cartTotalPrice < this.progressSettings.tierFourAmount * rate && this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          text = this.progressSettings.tierFourText.replace('$money', currency + ((this.progressSettings.tierFourAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else {
          text = !this.isFirstInCart() ? this.progressSettings.tierThreeFullfilText : this.progressSettings.tierFourFullfilText
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]')) {
            this.querySelector('[data-tier="one"]').style.background = `white`
          }
          if (this.querySelector('[data-tier="two"]')) {
            this.querySelector('[data-tier="two"]').style.background = `white`
            this.querySelector('#one-bar-tier-two-title').classList.add('fullfil')
          }
          if (this.querySelector('[data-tier="three"]')) {
            this.querySelector('[data-tier="three"]').style.background = `white`
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
          this.querySelector('#one-bar-tier-four-title')?.classList.add('fullfil')

          width = 100
        }

        if (this.querySelector('#one-bar-text')) {
          this.querySelector('#one-bar-text').innerHTML = text;
          this.querySelector('#one-bar-progress').style.width = `${width}%`;
        }
      }
    })
  }

  if (!customElements.get('free-gift-product')) {
    customElements.define('free-gift-product', class FreeGiftProduct extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        this.rate = Number(window.Shopify.currency.rate)

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.cartTotalPrice = this.cartItems.total_price + Number(this.getAttribute('data-threshold-amount'))

        this.cartTotalShippingPrice = this.cartTotalPrice
        this.cartTotalPrice = doExlcudeProductPrice(this.cartTotalPrice, this.cartItems)

        this.freeProductData = JSON.parse(this.querySelector('#free-product-variants').innerHTML)
        this.freeProductAmount = Number(this.getAttribute('data-free-number')) * this.rate

        if (this.cartTotalPrice >= this.freeProductAmount) {
          this.querySelector('.add-btn').classList.remove('disabled')
        }

        this.querySelectorAll(['.swatch-color', '.swatch-size']).forEach(item => {
          item.addEventListener('click', (event) => {
            event.target.closest('.swatch-wrap').querySelectorAll(['.swatch-color', '.swatch-size']).forEach(sub => sub.classList.remove('active'))
            event.target.classList.add('active')

            const options = Array.from(this.querySelectorAll('.swatch-wrap .active')).map(item => item.getAttribute('data-select-variant')).join(',')

            this.freeProductData.forEach(variant => {
              if (variant.options.join(',').includes(options) || variant.options.reverse().join(',').includes(options)) {
                this.querySelector('img').src = variant.featured_image.src
                this.querySelector('#free-product-btn').setAttribute('data-var-id', variant.id)
              }
            })
          })
        })

        const json = JSON.parse(this.querySelector('#free-product-json').innerHTML)
        this.freeGiftJson = json
        this.setText(json)

        if (this.freeGiftJson.variantType === 'select') {
          this.querySelector('.free-gift-select select')?.addEventListener('change', event => this.onVarBtnSelect(event))
        } else {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        }

        if (this.freeGiftJson.addToType === 'add-btn') {
          this.querySelector('.free-gift-product-buy').addEventListener('click', (event) => this.onAddBtnClick(event))
        }
        this.onCartUpdate()
      }
      rate = 0
      freeGiftJson = {}
      cartTotalPrice = 0
      cartTotalShippingPrice = 0
      cartItems = {}
      freeProductAmount = 0
      freeProductData = {}
      hasFreeProductInCart = false

      setText(data) {
        const freeAmount = Number(data.freeAmount * this.rate)
        const currency = this.freeGiftJson.currency

        if (this.querySelector('#free-product-title'))
          this.querySelector('#free-product-title').innerHTML = data.freeProductTitle.replace('$money', currency + (freeAmount / 100).toFixed(2))

        if (freeAmount > this.cartTotalPrice) {
          const unlockAmount = (freeAmount - this.cartTotalPrice) / 100
          if (this.querySelector('#free-product-subtitle'))
            this.querySelector('#free-product-subtitle').innerHTML = data.freeProductSubtitle.replace('$money', currency + unlockAmount.toFixed(2))

          if (this.freeGiftJson.addToType === 'add-btn')
            this.querySelector('#free-product-btn span').innerHTML = data.freeUnlockText.replace('$money', currency + unlockAmount.toFixed(2))
        } else if (this.freeGiftJson.addToType === 'add-btn') {
          this.querySelector('#free-product-btn span').innerHTML = data.freeBtnFullfilText
        }
      }

      onVarBtnSelect(event) {
        if (loading) {
          return
        }

        if (this.freeGiftJson.addToType !== 'add-btn') {
          const id = event.target.value
          loading = true
          event.target.closest('div').classList.add('free-gift-loading')
          CartJS.addItem(id)
        }
      }

      onCartUpdate() {
        const index = Number(this.getAttribute('data-index'))
        let isFirstInCart = false
        let isSecondInCart = false

        document.querySelectorAll('.header__cart__status').forEach(item => {
          item.innerHTML = this.cartItems.item_count > 9 ? '9+' : this.cartItems.item_count
          item.setAttribute('data-cart-count', this.cartItems.item_count)
        })

        if (!this.freeProductData) {
          return
        }

        console.log('-----------', index === 0, this.freeGiftJson.autoRemoveFirst, this.cartItems.total_price, this.freeGiftJson.secondGiftAmount)
        if (index === 0 && this.freeGiftJson.autoRemoveFirst && this.cartItems.total_price >= this.freeGiftJson.secondGiftAmount) {
          return
        }

        const secondProduct = document.querySelectorAll('free-gift-product')[1]
        if (index === 0 && secondProduct) {
          let freeProductData = JSON.parse(secondProduct.querySelector('#free-product-variants').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isSecondInCart = true;
                break
              }
            }
          }

          if (isSecondInCart) {
            document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
            return
          }
        }

        for (let i = 0; i < this.cartItems.items.length; i++) {
          const item = this.cartItems.items[i]
          for (const variant of this.freeProductData) {
            if (item.variant_id === variant.id && item.final_line_price === 0) {
              this.hasFreeProductInCart = true;
              this.freeProductIndex = i + 1
              break
            }
          }
        }

        if (index === 1 && this.hasFreeProductInCart && !this.freeGiftJson.autoRemoveFirst) {
          return
        }

        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (index === 1 && firstProduct) {
          let freeProductData = JSON.parse(firstProduct.querySelector('#free-product-variants').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isFirstInCart = true;
                break
              }
            }
          }

          //when first product in cart, show the progress bar for second product
          //add based on customer feedback

          if (isFirstInCart && document.querySelectorAll('.tier-four')) {
            const tierFourElements = document.querySelectorAll('.tier-four');

            tierFourElements.forEach(function (element) {
              element.style.display = "flex";
            });
          }
        }

        // 如果购物车金额达到了free gift的金额
        if (this.cartTotalPrice >= this.freeProductAmount) {
          // 如果购物车里面没有
          if (!this.hasFreeProductInCart) {
            // 如果只有一个variants
            if (this.freeProductData.length === 1 && this.freeGiftJson.addType === 'auto') {
              loading = true
              CartJS.addItem(this.freeProductData[0].id)
            } else {
              // this.style.display = 'block'
              if (index === 0) {
                this.style.display = 'block'
              } else if (isFirstInCart || this.freeGiftJson.autoRemoveFirst) {
                this.style.display = 'block'
              }
              if (this.freeGiftJson.variantType !== 'select') {
                this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.classList.remove('disabled'))
              } else {
                this.querySelector('.free-gift-select')?.classList.remove('disabled')
              }

              if (this.freeGiftJson.addToType == 'add-btn') {
                this.querySelector('#free-product-btn').classList.remove('disabled')
              }
            }
          } else {
            this.style.display = 'none'
            if (index === 0 && isFirstInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
            else if (index === 1 && this.hasFreeProductInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
          }
        } else if (this.hasFreeProductInCart && this.freeProductAmount > this.cartTotalPrice) {
          // this.style.display = 'block'
          if (index === 0) {
            this.style.display = 'block'
          } else if (isFirstInCart) {
            this.style.display = 'block';
          }
        } else {
          // this.style.display = 'block'
          if (index === 0) {
            this.style.display = 'block'
          } else if (isFirstInCart) {
            this.style.display = 'block'
          }
        }
      }

      onAddBtnClick(event) {
        if (event.target.closest('#free-product-btn').classList.contains('free-gift-loading') || event.target.closest('#free-product-btn').classList.contains('disabled')) {
          return
        }

        let id = ''
        if (this.freeGiftJson.variantType === 'select' && this.querySelector('select')) {
          id = this.querySelector('select').value
        } else if (this.querySelectorAll('.free-gift-varitant-btn').length) {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
            if (item.classList.contains('selected')) {
              id = item.getAttribute('data-var-id')
            }
          })
        } else {
          id = this.querySelector('#free-product-btn').getAttribute('data-var-id')
        }

        event.target.closest('#free-product-btn').classList.add('free-gift-loading')

        loading = true
        if (id) {
          CartJS.addItem(id)
        } else {
          CartJS.addItem(event.target.getAttribute('data-var-id'))
        }

        if (!this.freeGiftJson.autoRemoveFirst) {
          return
        }

        const index = Number(this.getAttribute('data-index'))
        const productId = Number(this.getAttribute('data-first-id'))
        if (index === 1) {
          const itemToRemove = this.cartItems.items.find(item => {
            return item.product_id === productId && item.final_line_price === 0
          })

          if (itemToRemove) {
            CartJS.removeItemById(itemToRemove.variant_id)
          }
        }
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
          item.classList.remove('selected')
        })
        this.querySelector('.free-gift-product-buy')?.classList.remove('disabled')

        event.target.classList.add('selected')


        if (this.freeGiftJson.addToType !== 'add-btn') {
          loading = true
          CartJS.addItem(event.target.getAttribute('data-var-id'))
          event.target.closest('.free-gift-varitant-btn').classList.add('free-gift-loading')
        }
      }
    })
  }

  if (!customElements.get('additional-products')) {
    customElements.define('additional-products', class AdditionalProducts extends HTMLElement {
      constructor() {
        super()

        this.freeGiftJson = JSON.parse(this.querySelector('#additional-product-json').innerHTML)

        this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', (event) => {
          this.onVarBtnSelect(event)
        }))

        if (this.querySelector('.add-btn')) {
          this.querySelectorAll('.add-btn').forEach(item => item.addEventListener('click', event => {
            let id = ''
            if (event.target.classList.contains('add-btn')) {
              event.target.classList.add('free-gift-loading')
              id = event.target.getAttribute('data-var-id')
            } else {
              event.target.parentNode.classList.add('free-gift-loading')
              id = event.target.parentNode.getAttribute('data-var-id')
            }

            loading = true
            CartJS.addItem(id)
          }))
        }

        this.onCartUpdate()
        // if (document.querySelector('.main-carousel')) {
        this.querySelectorAll('.main-carousel').forEach(item => {
          flkty = new Flickity(item, {
            cellAlign: 'left',
            prevNextButtons: false,
            contain: true,
            pageDots: true
          });
          function setEqualSlideHeights() {
            const cells = item.querySelectorAll('.carousel-cell');
            let maxHeight = 0;
            // Reset heights and find the tallest
            cells.forEach(cell => {
              cell.style.height = 'auto';
              const height = cell.offsetHeight;
              if (height > maxHeight) maxHeight = height;
            });
            // Set all to max height
            cells.forEach(cell => {
              cell.style.height = `${maxHeight}px`;
            });
            flkty.resize();
          }
          // Run after Flickity is ready
          flkty.on('ready', setEqualSlideHeights);
          setEqualSlideHeights();
          // Also run on window resize
          window.addEventListener('resize', () => {
            setEqualSlideHeights();
          });
          flkty.resize()
        })

        // }
      }

      cartItems = {}
      freeGiftJson = {}

      onCartUpdate() {
        this.cartItems = JSON.parse(document.querySelector('.cart-body #additional-cart-json').innerHTML)
        let count = 0
        document.querySelectorAll('.additional-products-container').forEach(container => { 
          count = 0
          container.querySelectorAll('.additional-product-card').forEach(card => {
            const id = Number(card.getAttribute('data-product-id'))
            if (!this.cartItems.items.find(item => item.product_id === id) && count < this.freeGiftJson.number) {
              card.style.display = 'flex'
              count += 1
            } else {
              const carouselEl = card.closest('.main-carousel');
              card.style.display = 'none'
              card.parentNode.removeChild(card)
              let flkty = Flickity.data(carouselEl);
              if (flkty) {
                flkty.destroy();
                flkty = new Flickity(carouselEl, {
                  cellAlign: 'left',
                  prevNextButtons: false,
                  contain: true,
                  pageDots: true
                });
              }
            }
          })
        })

        if (count === 0) {
          this.style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        // event.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none'
        loading = true
        CartJS.addItem(id)
        event.target.closest('.additional-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
      constructor() {
        super()

        this.variantType = this.getAttribute('data-variant-type')
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.variantType === 'btn')
          this.querySelectorAll('.upsell-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else
          this.querySelector('.free-gift-select select')?.addEventListener('change', (event) => this.onVarBtnSelect(event))


        this.querySelector('.add-btn')?.addEventListener('click', event => {
          let id = ''
          if (event.target.classList.contains('add-btn')) {
            event.target.classList.add('free-gift-loading')
            id = event.target.getAttribute('data-var-id')
          } else {
            event.target.parentNode.classList.add('free-gift-loading')
            id = event.target.parentNode.getAttribute('data-var-id')
          }

          loading = true
          CartJS.addItem(id)
        })

        this.querySelector('.upsell-item-close')?.addEventListener('click', () => {
          this.style.display = 'none'
        })

        this.onCartUpdate()
      }

      cartItems = {}
      addToType = ''
      variantType = ''

      onCartUpdate() {
        if (!this.cartItems.items.find(item => item.product_id === Number(this.getAttribute('data-product-id'))) && !localStorage.getItem(`upsell-hide-${this.getAttribute('data-product-id')}-${this.getAttribute('data-cart-id')}`)) {
          this.querySelector('.product-card').style.display = 'flex'
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
          this.querySelector('.product-card').style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.upsell-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  let completeTimeout = null

  $(document).on('cart.requestComplete', (event, cart) => {
    if (completeTimeout || window.displayUpgrade) {
      return
    }
    completeTimeout = setTimeout(() => {
      fetch(wetheme.cart_url + '?section_id=api__cart')
        .then((response) => response.text())
        .then((response) => {
          // document.querySelector('#cart-drawer').innerHTML = response
          document.querySelector('#CartContainer cart-header').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('cart-header').innerHTML
          document.querySelector('#CartContainer cart-header').querySelector('.close-cart').addEventListener('click', event => {
            toggleCart()
          })
          document.querySelector('#CartContainer .cart-body').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.cart-body').innerHTML
          document.querySelector('#CartContainer .cart-body').querySelector('checkout-btn').addEventListener('click', () => {
            let popConfirm = false;
            
            
            if (popConfirm) {
              document.querySelector('checkout-confirm').style.display = 'block'
            } else {
              location.href = '/checkout'
            }
          })
          if (!document.querySelector('#CartContainer').classList.contains('is-open')) {
            toggleCart()
          }
        })

      fetch('/cart.js')
        .then(res => res.json())
        .then(res => {
          document.querySelectorAll('.cart-item-count-header--quantity').forEach(item => {
            if (res.item_count > 0) {
              item.classList.remove('hide')
            } else {
              item.classList.add('hide')
            }

            item.innerHTML = res.item_count
          })
        })
      completeTimeout = null
    }, 100)
  })
})
